import IntercomService from '../service/IntercomService';
import MessageDispatcher, { NotifyOptions } from '../service/MessageDispatcher';

class ErrorUsecase {
  private readonly intercomService: IntercomService;
  private readonly messageDispatcher: MessageDispatcher;

  constructor({
    intercomService,
    messageDispatcher,
  }: {
    intercomService: IntercomService;
    messageDispatcher: MessageDispatcher;
  }) {
    this.intercomService = intercomService;
    this.messageDispatcher = messageDispatcher;
  }

  public requestContact = (): void => {
    this.intercomService.openNewMessage();
  };

  public showSnackbar = (message: string, notifyOptions: NotifyOptions = {}): void => {
    this.messageDispatcher.notifyUnimportant(message, notifyOptions);
  };
}

export default ErrorUsecase;
